<template>
  <div class="content">
    <div class="line">
      <div class="elem network" v-if="network_types.length > 0">
        <label> {{ translate("device.network_type") }} </label>
        <tree-select
            :options="network_types"
            :multiple="false"
            v-model="settings.network_type"
            :placeholder="translate('device.network_type')"
            :clearable="false"
            :searchable="true"
        />
      </div>

      <div class="elem vlan" v-if="Object.keys(settings).indexOf('vlan') > -1 && settings.network_type !== 'Trunk'">
        <fg-input
            v-model="settings.vlan"
            type="number"
            :label="translate('device.vlan')"
            :placeholder="translate('device.vlan')"
            :clearable="true"
        />
      </div>
    </div>

    <div class="line white-ip" v-if="settings.network_type === 'L2'">
      <div class="elem">
        <label>
          {{ translate('device.white_ip') }}
          <span class="mdi mdi-help-circle-outline" :title="translate('device.white_ip_title')"></span>
        </label>
        <div class="elem white-ip">
          <fg-input
              v-model="settings.ip"
              type="text"
              :placeholder="translate('device.white_ip')"
              :clearable="true"
          />
        </div>
      </div>
    </div>

    <div class="line" v-if="settings.network_type === 'L3/DHCP'">
      <div class="elem">
        <fg-input
            v-model="settings.local_ip"
            type="text"
            :label="translate('device.local_ip')"
            :placeholder="translate('device.local_ip')"
            :clearable="true"
        />
      </div>

      <div class="elem">
        <label> {{ translate('device.mask') }} </label>
        <tree-select
            :options="network_masks"
            :multiple="false"
            v-model="settings.mask"
            placeholder="Network Types"
            :clearable="true"
            :searchable="true"
            :max-height="120"
        />
      </div>
    </div>

    <div class="line" v-if="settings.network_type === 'L3/DHCP'">
      <div class="elem">
        <fg-input
            v-model="settings.gateway"
            type="text"
            :label="translate('device.gateway')"
            :placeholder="translate('device.gateway')"
            :clearable="true"
        />
      </div>

      <div class="elem">
        <label class="dns-label">
          {{ translate('device.dns') }}
          <span class="mdi mdi-help-circle-outline" :title="translate('device.dns_support')"></span>
        </label>
        <fg-input
            v-model="settings.dns"
            type="text"
            :placeholder="translate('device.dns')"
            :clearable="true"
        />
      </div>
    </div>
    <template v-if="settings.network_type === 'L3/DHCP' && Number(settings.dhcp_configurable) === 1">
      <div class="line dhcp-controls">
        <div class="elem">
          <div class="filter checkbox">
            <div class="info">
              {{ translate('device.network_settings.dhcp_custom_range') }}
            </div>
            <label
                class="switch"
                role="switch"
                tabindex="0"
                :aria-checked="!!settings.dhcp_custom_range"
                :aria-label="translate('device.network_settings.dhcp_custom_range')"
                @click.prevent="toggle_dhcp_range"
                @keydown.space.prevent="toggle_dhcp_range"
            >
              <input type="checkbox" v-model="settings.dhcp_custom_range" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <div class="elem">
          <fg-input
              v-model="settings.dhcp_interface"
              type="text"
              :label="translate('device.network_settings.dhcp_interface')"
              :readonly="true"
          />
        </div>
      </div>
      <div class="line" v-if="settings.dhcp_custom_range">
        <div class="elem" v-for="field in ['dhcp_start', 'dhcp_end', 'dhcp_mask']" :key="field">
          <fg-input
              v-model="settings[field]"
              type="text"
              :label="translate('device.network_settings.' + field)"
              :placeholder="translate('device.network_settings.' + field)"
              :clearable="true"
          />
        </div>
      </div>
    </template>
  </div>
</template>
<script>

const main_params = ["ip", "local_ip", "mask", "gateway", "dns"]
const dhcp_params = ['dhcp_start', 'dhcp_end', 'dhcp_mask']

export default {
  name: "EditNetworkSettingsInfo",
  props: ["network_settings"],

  data() {
    return {
      settings: {}
    };
  },

  computed:{
    network_types(){
      let types = []
      if (this.network_settings.network_types){
        Object.keys(this.network_settings.network_types).forEach((key) => {
          types.push({ id: key, label: this.translate("device.network_settings." + key) })
          if (this.network_settings.network_types[key]){
            this.settings.network_type = key
          }
        })
      }
      return types
    },
    network_masks(){
      let masks = []
      for (let i = 30; i > 7; i--) {
        masks.push({id: i, label: i})
      }
      return masks
    }
  },

  created() {
    this.settings = JSON.parse(JSON.stringify(this.network_settings))
    if (Number(this.settings.dhcp_configurable) === 1) {
      this.$set(this.settings, 'dhcp_custom_range', this.settings.dhcp_custom_range == null ? null : Number(this.settings.dhcp_custom_range) === 1)
      dhcp_params.forEach(field => {
        if (!(field in this.settings)) this.$set(this.settings, field, '')
      })
    }
    main_params.forEach(item => {
      if (!(Object.keys(this.settings).indexOf(item) > -1)) this.$set(this.settings, item, item === "mask" ? null : "")
    })
  },

  watch:{
    settings:{
      deep: true,
      handler(){
        this.$emit("update_settings", this.settings)
      }
    }
  },

  methods: {
    toggle_dhcp_range() {
      this.settings.dhcp_custom_range = !this.settings.dhcp_custom_range
      if (this.settings.dhcp_custom_range) {
        const defaults = {
          dhcp_start: '192.168.0.2',
          dhcp_end: '192.168.0.254',
          dhcp_mask: '255.255.255.0'
        }
        dhcp_params.forEach(field => {
          if (!this.settings[field]) this.$set(this.settings, field, defaults[field])
        })
      }
    },
    cancel() {
      this.$emit("close");
    },
  },
};
</script>

<style lang='scss' scoped>
.content {
  .dns-label {
    margin-bottom: 0;
  }
  .line.dhcp-controls {
    align-items: center;
    margin-bottom: 10px;
    .filter.checkbox,
    .form-group {
      margin-bottom: 0;
      margin-top: 0;
    }
  }
}
.modal_edit_profile {
  padding: 10px;
  .header{
    text-align: center;
    .title{
      margin: 10px 0;
    }
  }
  .content{
    min-height: 150px;

    .line{
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      @media (max-width:768px) {
        flex-direction: column;
      }
      &.backup{
        padding: 10px 0;
        border-bottom: 1px solid #E3E3E3;
        border-top: 1px solid #E3E3E3;
      }
      .elem{
        width: 100%;
        label{
          margin: 0;
        }
        .modems{
          display: flex;
          align-items: center;
          justify-content: center;
          .filter{
            margin: 0;
          }
        }
      }
      .network{
        width: 49.5%;
      }
      .vlan{
        width: 25%;
      }
      .white-ip{
        width: 49.5%;
        .form-group{
          width: 100%;
        }
      }
    }
  }

  .label{
    display: inline-block;
    width: 100%;
    text-align: center;
    color: #66615b;
    font-size: 16px;
    padding: 10px 0;
    margin-bottom: 0;
  }
}
.marginButton {
  margin: 5px;
}
.v-spinner {
  margin-bottom: 10px;
}
.tdFont {
  font-weight: bold;
}
.block {
  text-align: right;
}
</style>
